import React, { useState, useEffect, useRef } from 'react';
import { Play, Pause, Volume2, VolumeX, Heart, Radio } from 'lucide-react';
// import WaveformVisualizer from './WaveformVisualizer';  // Disabled temporarily to fix audio playback

/**
 *player link
 */
const Player = ({ currentTrack, isPlaying, onPlayPause, favorites, onToggleFavorite, onNext, onPrevious, playbackMode, onTogglePlaybackMode, onToggleShuffle, isShuffled, onTrackEnd }) => {
  const audioRef = useRef(null);
  const [volume, setVolume] = useState(0.7);
  const [isMuted, setIsMuted] = useState(false);
  const [currentTime, setCurrentTime] = useState(0);
  const [duration, setDuration] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  // Initialize audio element on mount
  useEffect(() => {
    if (audioRef.current) {
      console.log('Initializing audio element...');
      audioRef.current.volume = 0.7;
      audioRef.current.muted = false;
      console.log('Audio initialized with volume:', audioRef.current.volume);
    }
  }, []);

  useEffect(() => {
    if (audioRef.current) {
     // const sourceUrl = 'http://zmu.ddns.net:8000/stream';
    // const sourceUrl = 'https://odd-lab-61abradio.bailal123.workers.dev/';
    const sourceUrl = 'https://play.radioking.io/arabic3';


//const sourceUrl = '/radio.php';
      console.log('Loading live radio stream');
      console.log('Track URL:', sourceUrl);
      
      audioRef.current.pause();
      audioRef.current.src = sourceUrl;
      audioRef.current.load();
      setIsLoading(true);
      
      audioRef.current.onerror = (e) => {
        console.error('Audio loading error:', e);
        console.error('Failed to load:', sourceUrl, e?.target?.error);
        setIsLoading(false);
      };
      
      audioRef.current.oncanplay = () => {
        console.log('Audio ready to play, readyState:', audioRef.current.readyState);
        setIsLoading(false);
      };
    }
  }, [currentTrack]);

  // Handle play/pause
  useEffect(() => {
    console.log('=== Play/Pause effect triggered ===');
    console.log('isPlaying:', isPlaying);
    console.log('audioRef.current exists:', !!audioRef.current);
    console.log('currentTrack:', currentTrack?.titleEn);
    
    if (!audioRef.current) {
      console.log('No audio ref yet');
      return;
    }
    
    if (isPlaying) {
      console.log('Attempting to play audio...');
      console.log('Audio element ready state:', audioRef.current.readyState);
      console.log('Audio element paused:', audioRef.current.paused);
      console.log('Audio element src:', audioRef.current.src);
      
      // Wait a bit if not ready
      if (audioRef.current.readyState < 2) {
        console.log('Audio not ready yet, waiting for canplay event...');
        const playWhenReady = () => {
          console.log('Audio now ready, playing...');
          audioRef.current.play()
            .then(() => console.log('✓ Audio playing successfully'))
            .catch(err => console.error('✗ Play error:', err));
          audioRef.current.removeEventListener('canplay', playWhenReady);
        };
        audioRef.current.addEventListener('canplay', playWhenReady);
        return;
      }
      
      const playPromise = audioRef.current.play();
      
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            console.log('✓ Audio playing successfully');
            console.log('Current time:', audioRef.current.currentTime);
            console.log('Duration:', audioRef.current.duration);
            console.log('Volume:', audioRef.current.volume);
            console.log('Muted:', audioRef.current.muted);
            console.log('Paused:', audioRef.current.paused);
            
            // Check if audio is actually advancing
            setTimeout(() => {
              console.log('After 2 seconds - Current time:', audioRef.current?.currentTime);
              console.log('After 2 seconds - Paused:', audioRef.current?.paused);
            }, 2000);
          })
          .catch(err => {
            console.error('✗ Play error:', err);
            console.error('Error name:', err.name);
            console.error('Error message:', err.message);
          });
      }
    } else {
      console.log('Pausing audio...');
      audioRef.current.pause();
    }
  }, [isPlaying, currentTrack]);

  // Handle volume changes
  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = isMuted ? 0 : volume;
    }
  }, [volume, isMuted]);

  // Time update handler
  const handleTimeUpdate = () => {
    if (audioRef.current) {
      setCurrentTime(audioRef.current.currentTime);
    }
  };

  // Metadata loaded handler
  const handleLoadedMetadata = () => {
    if (audioRef.current) {
      console.log('Audio metadata loaded, duration:', audioRef.current.duration);
      setDuration(audioRef.current.duration);
      setIsLoading(false);
    }
  };

  // Progress bar click handler
  const handleProgressClick = (e) => {
    const progressBar = e.currentTarget;
    const clickPosition = (e.clientX - progressBar.getBoundingClientRect().left) / progressBar.offsetWidth;
    const newTime = clickPosition * duration;
    
    if (audioRef.current) {
      audioRef.current.currentTime = newTime;
      setCurrentTime(newTime);
    }
  };

  // Format time to MM:SS
  const formatTime = (time) => {
    if (isNaN(time)) return '0:00';
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  const isFavorite = currentTrack && favorites.includes(currentTrack.id);

  return (
    <div className="bg-gradient-to-br from-lightBeige via-white to-beige/30 rounded-2xl shadow-2xl overflow-hidden border-2 border-gold/30 relative animate-fade-in hover:shadow-3xl transition-all duration-500 animate-gradient">
      {/* Background Image */}
      <div className="absolute inset-0 pointer-events-none">
        <img 
          src={require('../assest/images/360_F_331500233_rBnPlY3OSFE0l6Fzbf7uZvvMVOFVXbTF.jpg')} 
          alt="Broadcasting Background" 
          className="w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-white/40 to-white/30"></div>
      </div>

      {/* Audio Element */}
      <audio
        ref={audioRef}
        onTimeUpdate={handleTimeUpdate}
        onLoadedMetadata={handleLoadedMetadata}
        onEnded={() => {
          onPlayPause(false);
          if (onTrackEnd) {
            onTrackEnd();
          }
        }}
        preload="auto"
        style={{ display: 'none' }}
      />

      {/* Player Header */}
      <div className="relative p-4 md:p-6 lg:p-8 overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0">
          <img 
            src={require('../assest/New folder/20231018152136397XT.jpg')} 
            alt="Broadcasting Background" 
            className="w-full h-full object-cover"
            style={{objectFit: 'cover', objectPosition: 'center top'}}
          />
          {/* Dark Overlay for text readability */}
          <div className="absolute inset-0 bg-gradient-to-br from-black/60 via-black/50 to-black/60"></div>
          {/* Gradient overlay */}
          
       <div className="absolute inset-0 bg-gradient-to-r from-white/90 to-[#F5E6C8]/70 backdrop-blur-[2px]"></div>
        </div>

        {/* Content */}
        <div className="relative z-10">
          <div className="flex items-center justify-between mb-3 md:mb-4 lg:mb-6">
         {/*    <div className="flex items-center space-x-2 space-x-reverse">
              {currentTrack?.isLive && (
                <div className="flex items-center space-x-1 md:space-x-2 space-x-reverse animate-bounce-slow bg-gradient-to-r from-gold to-gold-dark px-2 py-1 md:px-4 md:py-2 rounded-full shadow-xl">
                  <Radio className="w-4 h-4 md:w-6 md:h-6 text-white animate-pulse" />
               {/*    <span className="text-white font-bold text-xs md:text-base animate-pulse">مباشر</span> 
                </div>
              )}
            </div> */}
           {/*  <button
              onClick={() => currentTrack && onToggleFavorite(currentTrack.id)}
              className={`p-2 md:p-3 rounded-full transition-all duration-300 shadow-lg hover:scale-110 ${
                isFavorite 
                  ? 'bg-red-500 text-white scale-110 animate-pulse-glow' 
                  : 'bg-white/90 text-red-500 hover:bg-white'
              }`}
              aria-label="Add to favorites"
            >
              <Heart className={`w-5 h-5 md:w-6 md:h-6 ${isFavorite ? 'fill-current' : ''}`} />
            </button> */}
          </div>

          {/* Track Info with Audio Bars Animation */}
          <div className="text-center mb-3 md:mb-4 lg:mb-6">
            {/* Audio Bars Visualizer Background - Always visible */}
            <div className="flex items-center justify-center gap-1 sm:gap-2 md:gap-3 px-2 md:px-4 mb-4 h-16 md:h-20">
 <div className="w-full flex justify-center items-center">
<img 
  src={require('../assest/images/logoanimation.gif')} 
  alt="GIF Animation" 
  className="w-full max-w-[1400px] h-auto object-contain mix-blend-screen"
/>
</div>       </div>
            
            {/* Track Title */}
            {/* <p className="text-base sm:text-lg md:text-xl lg:text-l text-white font-bold px-2" style={{textShadow: '3px 3px 12px rgba(0,0,0,0.8)'}}>
              {currentTrack?.titleAr || 'لا يوجد مقطع محدد'}
            </p> */}
          </div>
        </div>
      </div>

      {/* Waveform Visualizer - Disabled temporarily to fix audio playback */}
      {/* 
      <div className={`bg-black bg-opacity-40 px-6 py-4 ${isPlaying ? 'animate-glow' : ''}`}>
        <WaveformVisualizer 
          audioRef={audioRef} 
          isPlaying={isPlaying}
          currentTrack={currentTrack}
        />
      </div>
      */}

      {/* Progress Bar */}
      <div className="px-4 py-3 md:px-6 md:py-4 lg:px-8 lg:py-6 relative overflow-hidden">
        <div className="relative flex items-center space-x-2 md:space-x-3 space-x-reverse mb-2">
          <span className="text-xs sm:text-sm md:text-base text-primary font-bold min-w-[40px] md:min-w-[50px] bg-gradient-to-r from-gold to-lightBeige px-2 py-1 md:px-3 md:py-2 rounded-md md:rounded-lg shadow-lg text-center">
        {formatTime(currentTime)}
          </span>
          
          {/* Progress Container with Waves Behind */}
          <div className="flex-1 relative">
            {/* Audio Waves - Behind Progress Bar */}
            <div className="absolute inset-0 flex items-center justify-center gap-0.5 sm:gap-1 md:gap-1.5 px-1 pointer-events-none opacity-50 -translate-y-1">
            {/* Pattern 1 */}
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>

{/* Pattern 2 */}
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>

{/* Pattern 3 */}
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>
          
          <div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>

{/* Pattern 2 */}
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>

{/* Pattern 3 */}
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>
     
     {/* Pattern 2 */}
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>

{/* Pattern 3 */}
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-white/70 rounded-full animate-audio-bar-1"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-4 sm:h-5 md:h-6 bg-white/60 rounded-full animate-audio-bar-2"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-2 sm:h-3 md:h-4 bg-white/50 rounded-full animate-audio-bar-3"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-5 sm:h-6 md:h-7 bg-gold/70 rounded-full animate-audio-bar-4"></div>
<div className="w-1 sm:w-1.5 md:w-2 h-3 sm:h-4 md:h-5 bg-gold/60 rounded-full animate-audio-bar-5"></div>
       </div>
            
            {/* Progress Bar - On Top of Waves */}
            <div
              className="h-2 md:h-3 bg-white/40 rounded-full cursor-pointer group relative overflow-hidden shadow-inner backdrop-blur-sm z-10"
              onClick={handleProgressClick}
            >
              <div
                className="h-full bg-gradient-to-r from-gold via-gold-light to-lightBeige rounded-full transition-all duration-150 relative animate-pulse-gentle shadow-md"
                style={{ width: `${duration ? (currentTime / duration) * 100 : 0}%` }}
              >
                <div className="absolute right-0 top-1/2 transform -translate-y-1/2 w-4 h-4 md:w-5 md:h-5 bg-white rounded-full shadow-xl opacity-100 group-hover:scale-125 transition-all animate-float"></div>
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/30 to-transparent animate-shimmer"></div>
              </div>
            </div>
          </div>
          
          <span className="text-xs sm:text-sm md:text-base text-primary font-bold min-w-[40px] md:min-w-[50px] bg-gradient-to-r from-gold to-lightBeige px-2 py-1 md:px-3 md:py-2 rounded-md md:rounded-lg shadow-lg text-center">
         {/*   {formatTime(duration)}  */}
          </span>
        </div>
      </div>

      {/* Simple Controls - Radio Style */}
      <div className="px-4 py-4 md:px-6 md:py-5 lg:px-8 lg:py-6">
        <div className="flex flex-wrap gap-3 items-center justify-center">
          {/* Play/Pause Button - Main Control */}
          <button
            onClick={() => onPlayPause(!isPlaying)}
            disabled={isLoading}
            className="group relative flex-1 min-w-[200px] max-w-md"
          >
            <div className="absolute -inset-1 bg-gradient-to-r from-gold via-gold-light to-lightBeige rounded-xl blur-md opacity-50 group-hover:opacity-75 transition-opacity"></div>
            
            <div className={`relative bg-gradient-to-r from-gold to-lightBeige text-primary rounded-xl px-8 py-4 shadow-2xl transform transition-all duration-300 border-2 border-gold/30 flex items-center justify-center gap-3 ${
              isPlaying ? 'scale-105' : 'hover:scale-105'
            }`}>
              {isLoading ? (
                <>
                  <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                  <span className="text-xl font-bold">جاري التحميل...</span>
                </>
              ) : isPlaying ? (
                <>
                  <Pause className="w-6 h-6" fill="currentColor" />
                  <span className="text-xl font-bold">إيقاف</span>
                </>
              ) : (
                <>
                  <Play className="w-6 h-6" fill="currentColor" />
                  <span className="text-xl font-bold">استمع الآن</span>
                </>
              )}
            </div>
          </button>

          {/* Volume Control - Compact */}
          <div className="flex items-center gap-2 bg-white/90 backdrop-blur-md rounded-xl px-4 py-3 border-2 border-primary/30 shadow-xl">
            <button
              onClick={() => setIsMuted(!isMuted)}
              className="text-primary hover:text-gold transition-colors"
            >
              {isMuted || volume === 0 ? (
                <VolumeX className="w-5 h-5" />
              ) : (
                <Volume2 className="w-5 h-5" />
              )}
            </button>
            
            <div className="relative w-20">
              <div className="h-1.5 bg-beige/30 rounded-full overflow-hidden">
                <div 
                  className="bg-gradient-to-r from-gold to-lightBeige h-full rounded-full transition-all duration-300"
                  style={{ width: `${isMuted ? 0 : volume * 100}%` }}
                ></div>
              </div>
              <input
                type="range"
                min="0"
                max="100"
                value={isMuted ? 0 : volume * 100}
                onChange={(e) => {
                  const newVolume = parseInt(e.target.value) / 100;
                  setVolume(newVolume);
                  if (audioRef.current) {
                    audioRef.current.volume = newVolume;
                  }
                  if (isMuted) setIsMuted(false);
                }}
                className="absolute inset-0 opacity-0 cursor-pointer w-full"
              />
            </div>
            
            <span className="text-primary font-bold text-xs min-w-[2rem]">
              {isMuted ? 0 : Math.round(volume * 100)}%
            </span>
          </div>

          {/* Favorite Button */}
     {/*      <button
            onClick={() => onToggleFavorite(currentTrack)}
            disabled={!currentTrack}
            className={`p-3 rounded-xl transition-all shadow-lg hover:scale-110 ${
              isFavorite 
                ? 'bg-gradient-to-r from-red-500 to-pink-500 text-white' 
                : 'bg-white/90 text-gray-700 hover:bg-white hover:text-red-500'
            }`}
            title={isFavorite ? 'إزالة من المفضلة' : 'إضافة للمفضلة'}
          >
            <Heart className={`w-5 h-5 ${isFavorite ? 'fill-current' : ''}`} />
          </button> */}
        </div>
      </div>

      {/* Program Info Section */}
      {currentTrack && (
        <div className="px-4 py-4 md:px-6 md:py-5 lg:px-8 lg:py-6 bg-gradient-to-r from-gold/20 via-beige/30 to-gold/20 backdrop-blur-sm border-t border-gold/30">
          <div className="flex gap-4 md:gap-6 items-start">
            {/* Program Image */}
           {/*  <div className="flex-shrink-0">
              <div className="relative w-28 h-28 md:w-36 md:h-36 lg:w-40 lg:h-40 rounded-2xl overflow-hidden shadow-2xl border-3 border-gold">
                <img
                  src={currentTrack.image || require('../assest/images/images (4).jpg')}
                  alt={currentTrack.titleAr}
                  className="w-full h-full object-cover"
                />
                {currentTrack.isLive && (
                  <div className="absolute top-2 right-2 bg-gradient-to-r from-gold to-gold-dark text-white text-xs md:text-sm px-3 py-1 rounded-full animate-pulse font-bold shadow-lg flex items-center gap-1">
                    <span className="w-2 h-2 bg-white rounded-full animate-ping"></span>
                    مباشر
                  </div>
                )}
              </div>
            </div> */}

            {/* Program Details */}
            <div className="flex-1 min-w-0">
              <h3 className="text-primary font-bold text-xl md:text-2xl mb-2 truncate drop-shadow-lg pl-2">
                {currentTrack.titleAr}
              </h3>
              {/* <p className="text-beige-dark text-sm md:text-base mb-3 line-clamp-2 leading-relaxed">
                {currentTrack.description || 'برنامج إذاعي متميز يقدم محتوى شيق ومفيد للمستمعين'}
              </p> */}
              
              {/* Time Info */}
              <div className="flex flex-wrap gap-2 md:gap-3 text-xs md:text-sm">
                {/* Current Time */}
                <div className="flex items-center gap-1.5 bg-gold text-white px-3 py-1.5 rounded-lg shadow-md font-bold">
                  <Radio className="w-4 h-4" />
                  <span>الآن: {new Date().toLocaleTimeString('ar-EG', { hour: '2-digit', minute: '2-digit' })}</span>
                </div>
                
                {currentTrack.time && (
                  <div className="flex items-center gap-1.5 bg-gold/80 text-white px-3 py-1.5 rounded-lg shadow-md font-medium">
                    <span>وقت البرنامج: {currentTrack.time}</span>
                  </div>
                )}
                
                {currentTrack.duration && !currentTrack.isLive && (
                  <div className="flex items-center gap-1.5 bg-[#8B7355]/70 text-white px-3 py-1.5 rounded-lg shadow-md font-medium">
                    <span>المدة: {currentTrack.duration}</span>
                  </div>
                )}
                
                {currentTrack.presenter && (
                  <div className="flex items-center gap-1.5 bg-white/90 text-[#8B7355] px-3 py-1.5 rounded-lg shadow-md font-bold border border-[#8B7355]/30">
                    <span>مع: {currentTrack.presenter}</span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Player;
